import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CustomersService } from './../../../services/customer/customers.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kv-loyalty-info-customers',
  templateUrl: 'loyalty-info-customers.component.html'
})
export class LoyaltyInfoCustomersComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  listBlacklist: Array<{label: string, value: string}>;
  searchPressed = false;
  infoCustomersList: any[];

  constructor(
    private svcCustomers: CustomersService,
    private notifyService: MessageService,
    private translate: TranslateService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.listBlacklist = [];
    this.translate.get([
      'common.all',
      'card.active',
      'card.blacklist'
    ]).subscribe( t => {
      this.listBlacklist.push({label: t['common.all'], value: null});
      this.listBlacklist.push({label: t['card.blacklist'], value: '1'});
      this.listBlacklist.push({label: t['card.active'], value: '0'});
    });
  }

  onClickCustomer(customerCode, cardNo) {
    let params = [{ key: 'customerCode', value: customerCode }];
    let offset = 0, limit = 10;

    this.svcCustomers.list(offset, limit, params).subscribe(res => {
      if (res.data && res.data.length === 1 && res.data[0]) {
        if (res.data[0]['flg_company'] && res.data[0]['flg_company'] === 'S') {
          this.router.navigate(['/customers-details', cardNo, res.data[0]['id']]);
        } else if (res.data[0]['flg_company'] && res.data[0]['flg_company'] === 'N') {
          this.router.navigate(['/customers-details', cardNo, res.data[0]['id']]);
        }
      }
    });
  }

  onSearch(filters) {
    this.infoCustomersList = [];
    this.svcCustomers.getInfoCustomers(filters).subscribe( icList => {
      this.infoCustomersList = icList.data.anagrafiche;
      if (this.infoCustomersList.length === 0) {
        this.notifyService.add({severity: 'info', summary: 'Info', detail: 'Nessun risultato.'});
      }
      this.searchPressed = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-info-customers/loyalty-info-customers.component.ts